import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from '../screens/AdminDashboard/AdminDashboard';
import CreateGame from '../screens/CreateGame/CreateGame';
import AdminLoginRoutes from './AdminLoginRoutes';
import ManageStadium from '../screens/ManageStadium/ManageStadium';
import ManageGame from '../screens/ManageGame/ManageGame';
import AdminProfile from '../screens/AdminProfile/AdminProfile';
import { isManagementAdminRole } from '../utils/adminAuth';

function AdminRoutes({ isAuthenticated, onLogin, adminRole }) {
  const canManageAdminRoutes = adminRole ? isManagementAdminRole(adminRole) : true;

  return (
    <Routes>
      {isAuthenticated && (
        <>
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route
            path="/create-game"
            element={canManageAdminRoutes ? <CreateGame /> : <Navigate to="/dashboard" replace />}
          />
          <Route
            path="/edit-game/:gameId"
            element={canManageAdminRoutes ? <CreateGame mode="edit" /> : <Navigate to="/dashboard" replace />}
          />
          <Route
            path="/manage-stadium"
            element={canManageAdminRoutes ? <ManageStadium /> : <Navigate to="/dashboard" replace />}
          />
          <Route path="/manage-game/:gameId" element={<ManageGame adminRole={adminRole} />} />
          <Route path="/admin-profile" element={<AdminProfile />} />
        </>
      )}
      {!isAuthenticated && <Route path="/*" element={<AdminLoginRoutes onLogin={onLogin} />} />}
      <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
      <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

export default AdminRoutes;
